function initChrHero() {

  const hero = document.querySelector('.chr-hero');

  if (!hero) return;

  const slides = hero.querySelectorAll('.chr-slide');
  const dots = hero.querySelectorAll('.chr-dot');

  const prevBtn = hero.querySelector('.chr-arrow--prev');
  const nextBtn = hero.querySelector('.chr-arrow--next');

  const progressBar = hero.querySelector('.chr-progress__bar');

  if (!slides.length) return;

  let current = 0;
  let interval;

  let touchStartX = 0;
  let touchEndX = 0;

  const isEditor = Shopify.designMode;

  const autoplayEnabled = hero.dataset.autoplay === 'true';
  const autoplaySpeed = parseInt(hero.dataset.speed) * 1000;

  function animateProgress(){

    if(!progressBar) return;

    progressBar.style.transition = 'none';
    progressBar.style.width = '0%';

    setTimeout(() => {

      progressBar.style.transition =
        `width ${autoplaySpeed}ms linear`;

      progressBar.style.width = '100%';

    }, 50);

  }

  function showSlide(index){

    slides.forEach((slide) => {
      slide.classList.remove('is-active');
    });

    dots.forEach((dot) => {
      dot.classList.remove('is-active');
    });

    slides[index].classList.add('is-active');

    if(dots[index]){
      dots[index].classList.add('is-active');
    }

    current = index;

    if(autoplayEnabled){
      animateProgress();
    }

  }

  function nextSlide(){

    let next = current + 1;

    if(next >= slides.length){
      next = 0;
    }

    showSlide(next);

  }

  function prevSlide(){

    let prev = current - 1;

    if(prev < 0){
      prev = slides.length - 1;
    }

    showSlide(prev);

  }

  showSlide(0);

  if(slides.length > 1 && !isEditor && autoplayEnabled){

    interval = setInterval(() => {
      nextSlide();
    }, autoplaySpeed);

  }

  dots.forEach((dot, index) => {

    dot.addEventListener('click', () => {

      showSlide(index);

      if(interval){

        clearInterval(interval);

        interval = setInterval(() => {
          nextSlide();
        }, autoplaySpeed);

      }

    });

  });

  if(prevBtn){

    prevBtn.addEventListener('click', () => {

      prevSlide();

    });

  }

  if(nextBtn){

    nextBtn.addEventListener('click', () => {

      nextSlide();

    });

  }

  /* SWIPE */

  hero.addEventListener('touchstart', (e) => {

    touchStartX = e.changedTouches[0].screenX;

  });

  hero.addEventListener('touchend', (e) => {

    touchEndX = e.changedTouches[0].screenX;

    const swipeDistance = touchEndX - touchStartX;

    if(Math.abs(swipeDistance) < 50){
      return;
    }

    if(swipeDistance > 0){

      prevSlide();

    } else {

      nextSlide();

    }

  });

}

document.addEventListener('DOMContentLoaded', initChrHero);

document.addEventListener('shopify:section:load', initChrHero);

document.addEventListener('shopify:block:select', (event) => {

  const slide = event.target.closest('.chr-slide');

  if (!slide) return;

  document.querySelectorAll('.chr-slide').forEach((s) => {
    s.classList.remove('is-active');
  });

  slide.classList.add('is-active');

});